export const OrganizationSymbols = {
    OrganizationService: Symbol.for("OrganizationService"),
    OrganizationProvider: Symbol.for("OrganizationProvider")
}